import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { IconCheckCircle, IconPdf } from '@pentabd/icons';

import ProgressBar, {
  ProgressBarProps,
} from '../../atoms/progress-bar/ProgressBar';
import Text from '../../atoms/text/Text';

export interface FileInfoCardProps {
  title?: string;
  subtitle?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
  progressBar?: ProgressBarProps;
  secondaryComponent?: JSX.Element;
  customRow?: JSX.Element;
  onClickIcon?: () => void;
  withoutBg?: boolean;
  fixedWidth?: boolean;
}

const FileInfoCard = ({
  title,
  subtitle,
  startIcon,
  endIcon,
  className,
  progressBar,
  secondaryComponent,
  customRow,
  onClickIcon,
  withoutBg,
  fixedWidth,
}: FileInfoCardProps) => {
  return (
    <div
      className={classNames(
        {
          'bg-white rounded-6 border p-10 w-100': !withoutBg,
          'file-info-card': fixedWidth,
        },
        className,
      )}
    >
      <div className="d-flex gap-6">
        <div>{startIcon ? startIcon : <IconPdf size={40} fill="none" />}</div>
        <div className="w-100 d-flex flex-column gap-2">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex flex-column">
              <Text
                className={classNames('text-ellipsis', {
                  'file-info-card text-nowrap overflow-hidden': fixedWidth,
                })}
                weight="semibold"
                size="sm"
                color="title"
              >
                {title}
              </Text>
              <div className="d-flex justify-content-start align-items-center">
                {subtitle && (
                  <Text size="sm" color="subtitle1">
                    {subtitle}
                  </Text>
                )}
                {secondaryComponent && secondaryComponent}
              </div>
            </div>
            <div
              onClick={onClickIcon}
              className={classNames(onClickIcon && 'pointer')}
            >
              {endIcon ? (
                endIcon
              ) : progressBar?.progress === 100 ? (
                <IconCheckCircle
                  size={16}
                  fill={progressBar?.type ? progressBar?.type : 'dark'}
                />
              ) : null}
            </div>
          </div>
          {customRow && customRow}
          {progressBar && (
            <ProgressBar
              type={progressBar?.type}
              progress={progressBar?.progress}
              size={progressBar?.size}
              showProgressNumber={progressBar?.showProgressNumber}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FileInfoCard;
